// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","date":"G512aad Ge2e370 Gd6846a G66772c G86f8cb G81a5ae undefined Geb2b38"};